import { render, staticRenderFns } from "./ShopEditStaff.vue?vue&type=template&id=5437036a&scoped=true&"
import script from "./ShopEditStaff.vue?vue&type=script&lang=ts&"
export * from "./ShopEditStaff.vue?vue&type=script&lang=ts&"
import style0 from "./ShopEditStaff.vue?vue&type=style&index=0&id=5437036a&lang=scss&scoped=true&"
import style1 from "./ShopEditStaff.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5437036a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VSelect,VTextField})
